import React, { useState } from 'react';
import AddTrendingModal from './AddTrendingModal';
import TrendingList from './TrendingList';
import { ToastContainer } from 'react-toastify';

const TrendingManager = () => {
  const [trendingProducts, setTrendingProducts] = useState([
    {
      id: 1,
      productId: 'PRD-001',
      name: 'Purple Masho Eau de Parfum',
      image: 'https://example.com/purple-masho.jpg',
      isActive: true,
      order: 1,
      type: 'bestseller', // 'trending' or 'bestseller'
      expirationDate: '2023-12-31',
    },
    {
      id: 2,
      productId: 'PRD-002',
      name: 'Dream Signature Scent',
      image: 'https://example.com/dream-scent.jpg',
      isActive: true,
      order: 2,
      type: 'trending',
      expirationDate: '2023-11-30',
    },
    {
      id: 3,
      productId: 'PRD-003',
      name: 'Citrus Zest Cologne',
      image: 'https://example.com/citrus-zest.jpg',
      isActive: false,
      order: 3,
      type: 'bestseller',
      expirationDate: null,
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddTrending = (newProduct) => {
    setTrendingProducts([
      ...trendingProducts, 
      { 
        ...newProduct, 
        id: Date.now(), 
        order: trendingProducts.length + 1 
      }
    ]);
    setIsModalOpen(false);
  };

  const handleToggleActive = (id) => {
    setTrendingProducts(
      trendingProducts.map((product) =>
        product.id === id ? { ...product, isActive: !product.isActive } : product
      )
    );
  };

  const handleDeleteProduct = (id) => {
    setTrendingProducts(trendingProducts.filter((product) => product.id !== id));
  };

  const moveProduct = (id, direction) => {
    const index = trendingProducts.findIndex((product) => product.id === id);
    const newOrder = [...trendingProducts];

    if (direction === 'up' && index > 0) {
      [newOrder[index], newOrder[index - 1]] = [newOrder[index - 1], newOrder[index]];
    } else if (direction === 'down' && index < newOrder.length - 1) {
      [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
    }

    setTrendingProducts(newOrder);
  };

  const handleUpdateProduct = (id, updatedData) => {
    setTrendingProducts(
      trendingProducts.map((product) =>
        product.id === id ? { ...product, ...updatedData } : product
      )
    );
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Manage Trending/Bestseller Products</h2>
      <ToastContainer position="top-center" theme="colored" />

      {/* Add New Product Button */}
      <div className="flex justify-end mb-6">
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
        >
          Add Featured Product
        </button>
      </div>

      {/* Current Trending Products */}
      <TrendingList
        products={trendingProducts}
        onToggleActive={handleToggleActive}
        onDeleteProduct={handleDeleteProduct}
        onMoveProduct={moveProduct}
        onUpdateProduct={handleUpdateProduct}
      />

      {/* Modal for Adding New Product */}
      {isModalOpen && (
        <AddTrendingModal
          onClose={() => setIsModalOpen(false)}
          onAdd={handleAddTrending}
        />
      )}
    </div>
  );
};

export default TrendingManager;